module.exports = __webpack_public_path__ + "static/media/program.96ab3ffc.jpeg";